import {useEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createEnrollmentClient,enrollmentAccountKey,type EnrollmentClient} from '../client';
import {createDraft} from '../../browser-recovery/drafts';
import {emptyEnrollmentDraft,validEnrollmentDraft} from '../draft';
import type {EnrollmentAccount} from '../types';
const clients=new Map<string,EnrollmentClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function useEnrollmentClient(base:string,account:EnrollmentAccount,begin?:()=>()=>void){
 const key=enrollmentAccountKey(base,account),live=useRef(key);live.current=key;
 useEffect(()=>{live.current=key;return()=>{live.current='';};},[key]);
 if(!clients.has(key))clients.set(key,createEnrollmentClient(base,account,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,key,...state,locked:state.busy||!!state.pending||state.blocked};
}
export function useEnrollmentDraft(key:string,baseline:string){
 const store=useMemo(()=>createDraft(key,baseline,emptyEnrollmentDraft(),validEnrollmentDraft),[key,baseline]);
 const state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}
